<template>
  <AccessHandler
    :requiredRoleGroups="roleGroups"
    @accessChanged="(a: boolean) => (hasAccess = a)"
  />
  <MasterPage>
    <template v-if="hasAccess" v-slot:content>
      <main class="page-container">
        <header class="page-header">Manage Customer Contacts</header>
        <UITabContainer
          :tabs="[
            { id: 'byFacility', label: 'By Facility' },
            { id: 'byName', label: 'By Name' },
          ]"
        >
          <template v-slot:byFacility>
            <ByFacility />
          </template>
          <template v-slot:byName>
            <ByName />
          </template>
        </UITabContainer>
      </main>
      <GlobalFooter />
    </template>
  </MasterPage>
</template>

<script setup lang="ts">
import UITabContainer from "@/shared/ui/tabs/tab-container.vue";
import ByFacility from "./ByFacility.vue";
import ByName from "./ByName.vue";
import MasterPage from "../MasterPage.vue";
import { useMainStore } from "@/stores/useMainStore";
import GlobalFooter from "@/views/GlobalFooter.vue";
import AccessHandler from "@/shared/access/AccessHandler.vue";
import { ContactAppGroup, type RoleGroup } from "@/shared/access/RoleGroups";
import { ref } from "vue";

const main = useMainStore();

const roleGroups = [
  ContactAppGroup,
  {
    roles: [],
    validateRestrictionsAsync: async () => {
      return main.companySummary?.denials.every(
        (d) => !d.Contacts || d.Contacts.toUpperCase() !== "ALL"
      );
    },
  },
] as RoleGroup[];

const hasAccess = ref<boolean>(false);
</script>

<style scoped lang="scss">
.page-container {
  padding: 30px 30px 60px;
  min-height: calc(100vh - 142px);

  .page-header {
    font-size: 24px;
    line-height: 45px;
    font-weight: 600;
    margin: 0 0px 20px;
    border: none;
    padding: 0;
    text-transform: uppercase;
  }
}
</style>
